<template>
    <v-icon v-if="prerenderMode" class="logged-out">{{accountIcon}}</v-icon>
    <v-menu
        v-else
        :close-on-click="false"
        :close-on-content-click="false"
        content-class="account-dropdown"
        fixed
        nudge-bottom="5"
        offset-y
        v-model="accountDropdown"
        :attach="attach"
    >
        <template slot="activator">
            <v-btn
                class="account-dropdown-toggle"
                :class="buttonClass"
                :color="iconColor"
                @click.stop="!loggedOutUrl || isUserLoggedIn ? accountDropdown = !accountDropdown : null"
                :flat="isLoginBtnFlat"
                :icon="icon"
                :to="!isUserLoggedIn && loggedOutUrl ? loggedOutUrl : undefined"
            >
                <template v-if="iconPosition === 'start'">
                    <v-icon v-if="showLoggedInIcon && isUserLoggedIn" class="logged-in">{{accountIcon}}</v-icon>
                    <v-icon v-else-if="showLoggedOutIcon" class="logged-out">{{accountIcon}}</v-icon>
                    <span class="css-arrow"></span>
                </template>

                <span v-if="!isUserLoggedIn && loggedOutLabel" class="button-label">{{loggedOutLabel}}</span>
                <span v-if="isUserLoggedIn && loggedInLabel" class="button-label">{{loggedInLabel}}</span>

                <template v-if="iconPosition === 'end'">
                    <v-icon v-if="showLoggedInIcon && isUserLoggedIn" class="logged-in">{{accountIcon}}</v-icon>
                    <v-icon v-else-if="showLoggedOutIcon" class="logged-out">{{accountIcon}}</v-icon>
                    <span class="css-arrow"></span>
                </template>
            </v-btn>
        </template>

        <v-card v-if="isUserLoggedIn" class="text-xs-center" :class="{'logged-in': isUserLoggedIn}">
            <v-card-title class="pa-1">
                <v-spacer></v-spacer>
                <v-btn
                    class="ma-0"
                    @click.stop="accountDropdown = !accountDropdown"
                    flat
                    icon
                >
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <p v-if="loggedInWindowLabel" :class="loggedInWindowLabelClassName" v-html="$language.translate(loggedInWindowLabel)"></p>
                <p v-else-if="customerData.firstName" :class="loggedInWindowLabelClassName">{{customerData.firstName}}'s Konto</p>
                <p v-else :class="loggedInWindowLabelClassName">{{ 'My account' | translation }}</p>
                <v-btn
                    block
                    color="primary"
                    dark
                    large
                    to="/customer/wishlist"
                >
                    {{ 'Wishlist' | translation }}
                </v-btn>
                <v-btn
                    block
                    color="primary"
                    dark
                    large
                    to="/customer/orders"
                >
                    {{ 'Orders' | translation }}
                </v-btn>
                <v-divider class="my-3"></v-divider>
                <a
                    class="text-large"
                    href="#"
                    @click.prevent="logout()"
                >
                    {{ 'Logout' | translation }}
                </a>
            </v-card-text>
        </v-card>

        <v-container v-else grid-list-xl class="pa-0">
            <v-card class="text-xs-center">
                <v-card-title class="pa-1">
                    <v-spacer></v-spacer>
                    <v-btn
                        class="ma-0"
                        @click.stop="accountDropdown = !accountDropdown"
                        flat
                        icon
                    >
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>

                <login-form v-bind="loginFormConfig" :third-party-login-buttons-icons-only="true"/>

                <v-card-text>
                    <v-divider class="mb-3"></v-divider>
                    <p :class="registrationLabelClassName">{{ 'Register here' | translation }}</p>
                    <p :class="registrationLabelSubtitleClassName">{{ 'New on our webiste?' | translation }}</p>
                    <v-btn
                        block
                        color="primary"
                        dark
                        large
                        to="/customer/registration"
                    >
                        {{ 'Register now' | translation }}
                    </v-btn>
                </v-card-text>
            </v-card>
        </v-container>
    </v-menu>
</template>

<style>
.account-dropdown   {
    position: fixed !important;
}
</style>

<script>
    import {mapState, mapGetters, mapActions} from 'vuex';

    const moduleName = 'AccountNavigation';

    export default {
        name: moduleName,
        data() {
            return {
                accountDropdown: false,
            };
        },
        props: {
            isLoginBtnFlat: {
                type: Boolean,
                default: false,
            },
            accountIcon: {
                default: 'account_circle',
            },
            iconColor: {
                default: 'primary',
            },
            loggedOutLabel: String,
            icon: {
                default: true,
                type: Boolean,
            },
            buttonClass: String,
            loggedInLabel: String,
            loggedInWindowLabel: String,
            showIcon: Boolean,
            iconPosition: {
                type: String,
                default: 'end',
            },
            showLoggedInIcon: {
                type: Boolean,
                default: true,
            },
            showLoggedOutIcon: {
                type: Boolean,
                default: true,
            },
            loggedOutUrl: String,
            loginFormConfig: Object,
            registrationLabelClassName: {
                default: 'headline font-weight-bold mb-0',
            },
            registrationLabelSubtitleClassName: {
                default: '',
            },
            loggedInWindowLabelClassName: {
                default: 'headline font-weight-bold',
            },
            attach: {},
        },
        created() {
            this.loadCustomerData();
        },
        computed: {
            ...mapState('Customer', [
                'customerData',
            ]),
            ...mapGetters('Login', [
                'isUserLoggedIn',
            ]),
            ...mapState('PageContent', [
                'prerenderMode'
            ]),
        },
        methods: {
            ...mapActions('Customer', [
                'loadCustomerData',
            ]),
            ...mapActions('Login', [
                'logout',
            ]),
        },
        watch: {
            $route (to, from){
                this.accountDropdown = false;
            },
        },
    };
</script>